(() => {
  const root = document.querySelector('[data-nskin-chat]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const panel = root.querySelector('#nskin-chat-panel');
  const toggle = root.querySelector('[data-chat-toggle]');
  const close = root.querySelector('[data-chat-close]');
  const messages = root.querySelector('[data-chat-messages]');
  const quick = root.querySelector('[data-chat-quick]');
  const form = root.querySelector('[data-chat-form]');
  const input = root.querySelector('[data-chat-input]');
  const whatsapp = 'https://wa.me/27645134995';
  const booking = 'https://www.fresha.com/book-now/n-skin-by-namrata-ldkey8es/services?lid=3218745&share=true&pId=3112549';
  const directions = 'https://www.google.com/maps/search/?api=1&query=111%2011th%20Street%2C%20Parkmore%2C%20Sandton%2C%202196';
  const answers = {
    booking: { text: 'Appointments begin with understanding your skin and goals. You can view available services and times on Fresha, or message the clinic if you need help choosing.', label: 'View appointments on Fresha', url: booking },
    treatments: { text: 'N SKIN offers skin consultations, skin renewal treatments, peels, microneedling and laser hair removal. Namrata can help you choose a suitable starting point after a consultation.', label: 'Ask Namrata on WhatsApp', url: whatsapp },
    laser: { text: 'Laser hair removal is planned around your skin, hair and treatment area. Hair grows in cycles, so a course of sessions and consistent timing matter. Suitability, preparation and aftercare are discussed at consultation.', label: 'Ask about laser on WhatsApp', url: whatsapp },
    location: { text: 'Find N SKIN at 111 11th Street, Parkmore, Sandton, 2196. Visits are by appointment.', label: 'Get directions', url: directions },
    human: { text: 'For a personal question, please message N SKIN on WhatsApp at 064 513 4995. A member of the clinic team can take it from there.', label: 'Open WhatsApp', url: whatsapp },
    fallback: { text: 'I can help with bookings, treatments, laser hair removal and directions. For anything personal or specific to your skin, Namrata can help on WhatsApp.', label: 'Speak to N SKIN on WhatsApp', url: whatsapp }
  };
  const options = [['Book', 'booking'], ['Treatments', 'treatments'], ['Laser', 'laser'], ['Directions', 'location'], ['Speak to us', 'human']];
  function addMessage(text, fromUser = false, action) {
    const bubble = document.createElement('div');
    bubble.className = `nskin-chat__bubble${fromUser ? ' nskin-chat__bubble--user' : ''}`;
    bubble.textContent = text;
    if (action) {
      const link = document.createElement('a');
      link.href = action.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = action.label;
      bubble.append(document.createElement('br'), link);
    }
    messages.append(bubble);
    messages.scrollTop = messages.scrollHeight;
  }
  function reply(key, label) {
    addMessage(label, true);
    const answer = answers[key] || answers.fallback;
    addMessage(answer.text, false, answer);
  }
  function route(value) {
    const q = value.toLowerCase();
    if (/book|appoint|fresha|availability|consult/.test(q)) return 'booking';
    if (/laser|hair removal|diode/.test(q)) return 'laser';
    if (/treatment|facial|peel|microneed|skin renewal|product/.test(q)) return 'treatments';
    if (/where|address|location|parkmore|sandton|direction|hour|open/.test(q)) return 'location';
    if (/human|person|namrata|whatsapp|phone|call|speak|price|cost|medical|condition/.test(q)) return 'human';
    return 'fallback';
  }
  options.forEach(([label, key]) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.addEventListener('click', () => reply(key, label));
    quick.append(button);
  });
  addMessage('Hello and welcome to N SKIN by Namrata. Choose a topic below, or ask a short question.');
  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close N SKIN chat assistant' : 'Open N SKIN chat assistant');
    if (open) input.focus(); else toggle.focus();
  }
  toggle.addEventListener('click', () => setOpen(panel.hidden));
  close.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) setOpen(false); });
  form.addEventListener('submit', e => {
    e.preventDefault();
    const value = input.value.trim();
    if (!value) return;
    input.value = '';
    reply(route(value), value);
  });
})();
